export default {
  "nl": {
    "dashboard": {
      "greetings": "Hallo {first_name}",
      "titles": {
        "activityFeed": "Activiteiten",
        "assignedTasks": "Mijn Taken voor",
        "newsFeed": "Nieuwsoverzicht",
        "ongoingTickets": "In Behandeling",
        "openTickets": "Open",
        "tickets": "Gesprekken",
        "totalTickets": "Alle",
        "unreadTickets": "Ongelezen",
        "yourAssignedTickets": "Jouw toegewezen gesprekken"
      }
    }
  }
}